import React, { useState } from "react";
import s from "./ActivityDetails.module.scss";
import dayjs from "dayjs";
import { Skeleton } from "antd";
import Card from "./local components/Card";
import { useParams } from "react-router-dom";
import DisableApiKey from "../../../local components/DisableApiKey";
import ReusableModal from "../../../../../../../global components/Modal/Modal";
import { XCircleSolid } from "../../../../../../../global components/Icons/XCircleSolid";
import TableWrapper from "./local components/TableWrapper";
import useSWR from "swr";
import { APIKeyDetails } from "../../../../../../../libs/Utils/Types/APIManagement";
import { swrFetcher } from "../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../libs/api/userSession";
import clsx from "clsx";
function ActivityDetails() {
  const token = UseAuthToken();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { id } = useParams();

  const { data, isLoading, mutate } = useSWR<{data:APIKeyDetails}, any, any>(
    token ? [`api/admin/api-keys/${id}`, token] : null,
    swrFetcher
  );
  const handleModal = () => {
    setOpenModal((prev) => !prev);
  };
  return (
    <>
      <div className={s.wrapper}>
        <h3 className={s.title}>Activity details</h3>
        <div className={s.cardWrapper}>
          <Card
            isLoading={isLoading}
            title="Total Requests"
            value={data?.data.stats.totalVolume || 0}
          />
          <Card
            isLoading={isLoading}
            title="Successful Requests"
            value={data?.data.stats.successfulVolume || 0}
          />
          <Card
            isLoading={isLoading}
            title="Failed Request"
            value={data?.data.stats.failedVolume || 0}
          />
        </div>
        {isLoading ? (
          <div className={s.loadingWrapper}>
            <div className={s.item}>
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
            </div>
            <div className={s.item}>
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
            </div>
            <div className={s.item}>
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
            </div>
            <div className={s.item}>
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
            </div>
          </div>
        ) : (
          <div className={s.statWrapper}>
            <div className={s.item}>
              <h6 className={s.label}>API Key</h6>
              <p className={s.value}>{data?.data.keyPreview}</p>
            </div>
            <div className={s.item}>
              <h6 className={s.label}>Created by</h6>
              <p className={s.value}>
                {data?.data.createdBy.firstName + " " + data?.data.createdBy.lastName ||
                  "Not found"}
              </p>
            </div>
            <div className={s.item}>
              <h6 className={s.label}>Creation date</h6>
              <p className={s.value}>
                {dayjs.utc(data?.data.createdAt).local().format("YYYY-MM-DD hh:33:ss")}
              </p>
            </div>
            <div className={s.item}>
              <h6 className={s.label}>Last Used</h6>
              <p className={s.value}>
                {data?.data.lastUsedAt
                  ? dayjs.utc(data?.data.lastUsedAt).local().format("YYYY-MM-DD hh:33:ss")
                  : "Not yet used"}
              </p>
            </div>
            <div className={s.item}>
              <h6 className={s.label}>Status</h6>
              <p
                className={clsx(s.value, {
                  [s.active]: data?.data.status.toLowerCase().includes("active"),
                  [s.inactive]:
                    data?.data.status.toLowerCase().includes("inactive") ||
                    data?.data.status.toLowerCase().includes("disabled"),
                  [s.revoked]: data?.data.status.toLowerCase().includes("revoked"),
                })}
              >
                {data?.data.status}
              </p>
            </div>
          </div>
        )}
        <button
          disabled={data?.data.status.includes("revoked")}
          className={clsx(s.revokeBtn, {
            [s.disabled]: data?.data.status.includes("revoked"),
          })}
          onClick={handleModal}
        >
          <XCircleSolid className={s.icon} />
          Revoke API Key
        </button>
        <TableWrapper />
      </div>
      <ReusableModal
        isModalOpen={openModal}
        handleModal={handleModal}
        width={682}
      >
        <DisableApiKey
          emptyKey={data?.data.keyPreview || ""}
          handleModal={handleModal}
          mutate={mutate}
          id={id!}
        />
      </ReusableModal>
    </>
  );
}

export default ActivityDetails;
